import {
  AlertTriangle,
  Calendar,
  History,
  LayoutDashboard,
  Shield,
  User,
  Building2,
} from "lucide-react";
import type { LucideIcon } from "lucide-react";

export type RouteGroup = "oncall" | "manage";

export interface RouteConfig {
  id: string;
  name: string;
  path: string;
  icon: LucideIcon;
  group: RouteGroup;
  /** 관리자에게만 메뉴 노출 */
  adminOnly?: boolean;
}

export const routes: RouteConfig[] = [
  { id: "overview",     name: "대시보드",                          path: "/overview",                  icon: LayoutDashboard, group: "oncall"  },
  { id: "trigger",      name: "수동 알람 트리거",                  path: "/alert/trigger",             icon: AlertTriangle,   group: "oncall"  },
  { id: "schedule",     name: "스케줄 관리",                       path: "/schedule",                  icon: Calendar,        group: "oncall"  },
  { id: "policy",       name: "알람 및 에스컬레이션 정책 관리",    path: "/alert/escalation-policy",   icon: Shield,          group: "oncall"  },
  { id: "history",      name: "인시던트 발생 이력",                path: "/alert/history",             icon: History,         group: "oncall"  },
  { id: "members",      name: "사용자 관리",                       path: "/members",                   icon: User,            group: "manage",  adminOnly: true },
  { id: "teams",        name: "팀 관리",                           path: "/teams",                     icon: Building2,       group: "manage"  },
];
